import { ReactNode } from "react";
import { motion } from "framer-motion";

export interface MarketingCTAProps {
  children: ReactNode;
  delay?: number;
}

export default function MarketingCTA({ children, delay = 0.3 }: MarketingCTAProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay }}
      className="flex flex-col sm:flex-row gap-4 justify-center"
    >
      {children}
    </motion.div>
  );
}
